var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderProcessing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10343",
    "data-name": "Group 10343",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#dfc100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-box",
    transform: "translate(47.223 18.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M25,3H4.556A2.556,2.556,0,0,0,2,5.556V8.111a2.556,2.556,0,0,0,1.278,2.2V23.444A2.556,2.556,0,0,0,5.833,26H23.722a2.556,2.556,0,0,0,2.556-2.556V10.309a2.556,2.556,0,0,0,1.278-2.2V5.556A2.556,2.556,0,0,0,25,3ZM4.556,5.556H25V8.111H4.556ZM5.833,23.444V10.667H23.722V23.444Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M19093.016,22768.43a.921.921,0,0,1-.92-.92v-.279a3.479,3.479,0,0,1-.871-.51l-.248.143a.947.947,0,0,1-1.254-.336l-.459-.793a.927.927,0,0,1,.34-1.262l.23-.129a3.47,3.47,0,0,1,0-1.025l-.23-.133a.924.924,0,0,1-.34-1.258l.459-.8a.947.947,0,0,1,1.254-.336l.248.143a3.552,3.552,0,0,1,.871-.514v-.273a.918.918,0,0,1,.92-.92h.92a.919.919,0,0,1,.918.92v.273a3.727,3.727,0,0,1,.875.514l.242-.143a.945.945,0,0,1,1.254.336l.461.8a.922.922,0,0,1-.334,1.258l-.232.133a3.918,3.918,0,0,1,0,1.025l.232.129a.925.925,0,0,1,.334,1.262l-.461.793a.947.947,0,0,1-1.254.336l-.242-.143a3.646,3.646,0,0,1-.875.51v.279a.922.922,0,0,1-.918.92Zm-1.422-2.6a2.77,2.77,0,0,0,1.1.646.455.455,0,0,1,.324.436v.6h.92v-.6a.451.451,0,0,1,.322-.436,2.783,2.783,0,0,0,1.1-.646.471.471,0,0,1,.547-.066l.529.3.459-.789-.518-.3a.452.452,0,0,1-.215-.51,2.711,2.711,0,0,0,.074-.633,2.829,2.829,0,0,0-.074-.635.455.455,0,0,1,.215-.508l.518-.3-.459-.793-.529.3a.46.46,0,0,1-.547-.061,2.811,2.811,0,0,0-1.1-.648.45.45,0,0,1-.322-.439v-.6h-.92v.6a.454.454,0,0,1-.324.439,2.8,2.8,0,0,0-1.1.648.461.461,0,0,1-.549.061l-.521-.3-.459.793.516.3a.473.473,0,0,1,.217.508,2.536,2.536,0,0,0-.08.635,2.433,2.433,0,0,0,.08.633.469.469,0,0,1-.217.51l-.521.3.465.795.521-.3a.463.463,0,0,1,.238-.066A.446.446,0,0,1,19091.594,22765.826Zm.041-2a1.839,1.839,0,1,1,1.84,1.846A1.843,1.843,0,0,1,19091.635,22763.826Zm.92,0a.919.919,0,1,0,.92-.918A.934.934,0,0,0,19092.555,22763.826Z",
    transform: "translate(-19078.619 -22746.697)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderProcessing);
export default __webpack_public_path__ + "static/media/Order Processing.521b8202233bab1b67a0347d494532d2.svg";
export { ForwardRef as ReactComponent };